<div class="mat-button-row spacing--margin-top" *ngIf="isEditMode">
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-add-top"
    (click)="changeNumberOfLines('add-top')"
  >
    <mat-icon>add</mat-icon>
    <ng-container *ngIf="isWeanedPiglets()">{{
      'scheme-table.buttons.add-day-top' | translate
    }}</ng-container>
    <ng-container *ngIf="!isWeanedPiglets()">{{
      'scheme-table.buttons.add-top' | translate
    }}</ng-container>
  </button>
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-remove-top"
    [disabled]="tableRows?.length <= 1"
    (click)="changeNumberOfLines('remove-top')"
  >
    <mat-icon>remove</mat-icon>
    <ng-container *ngIf="isWeanedPiglets()">{{
      'scheme-table.buttons.remove-day-top' | translate
    }}</ng-container>
    <ng-container *ngIf="!isWeanedPiglets()">{{
      'scheme-table.buttons.remove-top' | translate
    }}</ng-container>
  </button>
</div>
<mat-table [dataSource]="datasource" data-test="scheme-table" [formGroup]="formGroup">
  <ng-container formArrayName="lines">
    <ng-container matColumnDef="week">
      <mat-header-cell class="slim-column table-header-cell" *matHeaderCellDef>
        <span>{{ 'scheme-table.weeknr' | translate }}</span>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__weeknr"
        [formGroupName]="i"
        class="slim-column"
      >
        {{ element.week }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="day">
      <mat-header-cell class="slim-column" *matHeaderCellDef>
        {{ 'scheme-table.day' | translate }}
      </mat-header-cell>
      <mat-cell class="slim-column" *matCellDef="let element" data-test="scheme-table__day">
        {{ element.day }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="weekAge">
      <mat-header-cell *matHeaderCellDef>
        {{ 'scheme-table.weekAge' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" data-test="scheme-table__weekage">
        {{ element.weekAge }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="age">
      <mat-header-cell *matHeaderCellDef> {{ getTableAgeHeader() | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element" data-test="scheme-table__age">
        {{ element.age }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="weight">
      <mat-header-cell *matHeaderCellDef> {{ 'scheme-table.weight' | translate }} </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__weight"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode">{{ element.weight | agrNumber: '1.1-1' }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'weight')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.1"
              data-test="scheme-table__weight_value"
              formControlName="weight"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="energyValue">
      <mat-header-cell *matHeaderCellDef>
        {{ 'scheme-table.energy_value' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__energy"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode || inputSystem !== 'EnergyDay'">{{
          element.energyValuePerDay | agrNumber: '1.2-2'
        }}</span>
        <ng-container *ngIf="isEditMode && inputSystem === 'EnergyDay'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'energyValue')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="scheme-table__energy_value"
              formControlName="energyValue"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lysine">
      <mat-header-cell class="lysine" *matHeaderCellDef>
        {{ 'scheme-table.lysine' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element"
        data-test="scheme-table__lysine"
        [ngClass]="highlight(element)"
        [matTooltip]="showLysine(element)"
        matTooltipPosition="left"
        class="lysine"
      >
        <span>{{ element.intestinalDigestibleLysinePerDay | agrNumber: '1.1-1' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="correctionFactor">
      <mat-header-cell class="factor" *matHeaderCellDef>
        {{ 'scheme-table.correction_factor' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__correction-factor"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{ element.correctionFactor | agrNumber: '1.1-1' }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'correctionFactor')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="scheme-table__correction-factor_value"
              formControlName="correctionFactor"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="phase1">
      <mat-header-cell *matHeaderCellDef> {{ 'scheme-table.phase1' | translate }} </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__phase1"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode">{{ element.consumptions[0]?.productIntakeInPercentage }}%</span>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Gradual'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <input
              matInput
              agrNumber
              [enableStepArrows]="false"
              [min]="0"
              [step]="1"
              data-test="scheme-table__phase1_value"
              formControlName="phase1"
            />
            <span matTextSuffix class="form-field-suffix--text">%</span>
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Abrupt'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <mat-select
              [hideSingleSelectionIndicator]="true"
              data-test="scheme-table__phase1_select"
              formControlName="phase1"
            >
              <mat-option [value]="0">0%</mat-option>
              <mat-option [value]="100">100%</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="phase2">
      <mat-header-cell *matHeaderCellDef> {{ 'scheme-table.phase2' | translate }} </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__phase2"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode">{{ element.consumptions[1]?.productIntakeInPercentage }}%</span>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Gradual'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <input
              matInput
              agrNumber
              [enableStepArrows]="false"
              [min]="0"
              [step]="1"
              data-test="scheme-table__phase2_value"
              formControlName="phase2"
            />
            <span matTextSuffix class="form-field-suffix--text">%</span>
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Abrupt'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <mat-select
              [hideSingleSelectionIndicator]="true"
              data-test="scheme-table__phase2_select"
              formControlName="phase2"
            >
              <mat-option [value]="0">0%</mat-option>
              <mat-option [value]="100">100%</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="phase3">
      <mat-header-cell *matHeaderCellDef> {{ 'scheme-table.phase3' | translate }} </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__phase3"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode">{{ element.consumptions[2]?.productIntakeInPercentage }}%</span>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Gradual'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <input
              matInput
              agrNumber
              [enableStepArrows]="false"
              [min]="0"
              [step]="1"
              data-test="scheme-table__phase3_value"
              formControlName="phase3"
            />
            <span matTextSuffix class="form-field-suffix--text">%</span>
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Abrupt'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <mat-select
              [hideSingleSelectionIndicator]="true"
              data-test="scheme-table__phase3_select"
              formControlName="phase3"
            >
              <mat-option [value]="0">0%</mat-option>
              <mat-option [value]="100">100%</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="phase4">
      <mat-header-cell *matHeaderCellDef> {{ 'scheme-table.phase4' | translate }} </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__phase4"
        [formGroupName]="i"
      >
        <span *ngIf="!isEditMode">{{ element.consumptions[3]?.productIntakeInPercentage }}%</span>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Gradual'">
          <mat-form-field
            floatLabel="auto"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <input
              matInput
              agrNumber
              [enableStepArrows]="false"
              [min]="0"
              [step]="1"
              data-test="scheme-table__phase4_value"
              formControlName="phase4"
            />
            <span matTextSuffix class="form-field-suffix--text">%</span>
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="isEditMode && phaseTransition === 'Abrupt'">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'percentage')"
          >
            <mat-select
              [hideSingleSelectionIndicator]="true"
              data-test="scheme-table__phase4_select"
              formControlName="phase4"
            >
              <mat-option [value]="0">0%</mat-option>
              <mat-option [value]="100">100%</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="dosator_feeding_times">
      <mat-header-cell *matHeaderCellDef class="dosator">
        {{ 'scheme-table.dosator_feeding_times' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__dosator-feeding-times"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{ element.feedingTimesPerDay | agrNumber: '1.0-0' }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'dosatorPosition')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="1"
              data-test="scheme-table__dosator_feeding_times_value"
              formControlName="dosator_feeding_times"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dosator_position_phase_1">
      <mat-header-cell *matHeaderCellDef class="dosator">
        {{ 'scheme-table.dosator_position_phase_1' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__dosator-position-phase-1"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{
          element.consumptions[0]?.dosatorPosition | agrNumber: '1.1-1'
        }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'dosatorPosition')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.1"
              data-test="scheme-table__dosator_position_phase_1_value"
              formControlName="dosator_position_phase_1"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dosator_position_phase_2">
      <mat-header-cell *matHeaderCellDef class="dosator">
        {{ 'scheme-table.dosator_position_phase_2' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__dosator-position-phase-2"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{
          element.consumptions[1]?.dosatorPosition | agrNumber: '1.1-1'
        }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'dosatorPosition')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.1"
              data-test="scheme-table__dosator_position_phase_2_value"
              formControlName="dosator_position_phase_2"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dosator_position_phase_3">
      <mat-header-cell *matHeaderCellDef class="dosator">
        {{ 'scheme-table.dosator_position_phase_3' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__dosator-position-phase-3"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{
          element.consumptions[2]?.dosatorPosition | agrNumber: '1.1-1'
        }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'dosatorPosition')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.1"
              data-test="scheme-table__dosator_position_phase_3_value"
              formControlName="dosator_position_phase_3"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dosator_position_phase_4">
      <mat-header-cell *matHeaderCellDef class="dosator">
        {{ 'scheme-table.dosator_position_phase_4' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__dosator_position_phase_4"
        [formGroupName]="i"
        class="factor"
      >
        <span *ngIf="!isEditMode">{{
          element.consumptions[3]?.dosatorPosition | agrNumber: '1.1-1'
        }}</span>
        <ng-container *ngIf="isEditMode">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="factor--input_field"
            [ngClass]="checkValidation(element, 'dosatorPosition')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.1"
              data-test="scheme-table__dosator_position_phase_4_value"
              formControlName="dosator_position_phase_4"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="foodPerDay">
      <mat-header-cell *matHeaderCellDef>
        {{ 'scheme-table.feed_per_day' | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let element; let i = index"
        data-test="scheme-table__feed-per-day"
        [formGroupName]="i"
      >
        <span *ngIf="(!isEditMode || inputSystem !== 'KgDay') && isWeanedPigletsFeedadvice()">
          {{ element.foodPerDay | agrNumber: '1.0-0' }}
        </span>
        <span *ngIf="(!isEditMode || inputSystem !== 'KgDay') && !isWeanedPigletsFeedadvice()">
          {{ element.foodPerDay * 1 | agrNumber: '1.2-2' }}
        </span>
        <ng-container *ngIf="isEditMode && inputSystem === 'KgDay'">
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            class="cell--input-field"
            [ngClass]="checkValidation(element, 'kgDay')"
          >
            <input
              matInput
              agrNumber
              [min]="0"
              [step]="0.01"
              data-test="scheme-table__feed-per-day_value"
              formControlName="foodPerDay"
            />
          </mat-form-field>
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cumulative">
      <mat-header-cell *matHeaderCellDef>
        {{ 'scheme-table.cumulative' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" data-test="scheme-table__cumulative">
        {{ element.cumulative | agrNumber: '1.1-1' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="invisible1">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products slim-column"
      ></mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible2">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products slim-column"
      ></mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible3">
      <mat-header-cell *matHeaderCellDef class="table-header__products"></mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible4">
      <mat-header-cell *matHeaderCellDef class="table-header__products"></mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible5">
      <mat-header-cell *matHeaderCellDef class="table-header__products">
        {{ 'scheme-table.feed_unit_kg' | translate }}
      </mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible6">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__energy-uom"
        data-test="scheme-table_energy-uom"
      >
        {{ 'settings.energy.short.' + (energySetting$ | async) | translate }}
      </mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible7">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products lysine"
        data-test="scheme-table_lysine-uom"
      >
        {{ 'settings.lysine.short.' + (lysineSetting$ | async) | translate }}
      </mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible8">
      <mat-header-cell *matHeaderCellDef class="table-header__products factor"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productPhase1">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products"
        data-test="scheme-table__phase1-product"
      >
        <span *ngIf="!isEditMode" [innerHTML]="getProductName(phases[0])"></span>
        <mat-select
          *ngIf="isEditMode"
          [hideSingleSelectionIndicator]="true"
          class="text--small spacing--margin-right"
          panelClass="mat-select-product-panel"
          [ngClass]="checkProductValidation(1)"
          [matTooltip]="getProductDropdownValue(1)?.name"
          [value]="getProductDropdownValue(1)"
          (selectionChange)="setProduct($event, phases[0])"
        >
          <mat-option *ngFor="let product of productsPhase1" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productPhase2">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products"
        data-test="scheme-table__phase2-product"
      >
        <span *ngIf="!isEditMode" [innerHTML]="getProductName(phases[1])"></span>
        <mat-select
          *ngIf="isEditMode"
          [hideSingleSelectionIndicator]="true"
          class="text--small spacing--margin-right"
          panelClass="mat-select-product-panel"
          [ngClass]="checkProductValidation(2)"
          [matTooltip]="getProductDropdownValue(2)?.name"
          [value]="getProductDropdownValue(2)"
          (selectionChange)="setProduct($event, phases[1])"
        >
          <mat-option *ngFor="let product of productsPhase2" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productPhase3">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products"
        data-test="scheme-table__phase3-product"
      >
        <span *ngIf="!isEditMode" [innerHTML]="getProductName(phases[2])"></span>
        <mat-select
          *ngIf="isEditMode"
          [hideSingleSelectionIndicator]="true"
          class="text--small spacing--margin-right"
          panelClass="mat-select-product-panel"
          [ngClass]="checkProductValidation(3)"
          [matTooltip]="getProductDropdownValue(3)?.name"
          [value]="getProductDropdownValue(3)"
          (selectionChange)="setProduct($event, phases[2])"
        >
          <mat-option *ngFor="let product of productsPhase3" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productPhase4">
      <mat-header-cell
        *matHeaderCellDef
        class="table-header__products"
        data-test="scheme-table__phase4-product"
      >
        <span *ngIf="!isEditMode" [innerHTML]="getProductName(phases[3])"></span>
        <mat-select
          *ngIf="isEditMode"
          [hideSingleSelectionIndicator]="true"
          class="text--small spacing--margin-right"
          panelClass="mat-select-product-panel"
          [ngClass]="checkProductValidation(4)"
          [matTooltip]="getProductDropdownValue(4)?.name"
          [value]="getProductDropdownValue(4)"
          (selectionChange)="setProduct($event, phases[3])"
        >
          <mat-option *ngFor="let product of productsPhase4" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productdosator_feeding_times">
      <mat-header-cell *matHeaderCellDef class="dosator"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productdosator_position_phase_1">
      <mat-header-cell *matHeaderCellDef class="dosator"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productdosator_position_phase_2">
      <mat-header-cell *matHeaderCellDef class="dosator"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productdosator_position_phase_3">
      <mat-header-cell *matHeaderCellDef class="dosator"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="productdosator_position_phase_4">
      <mat-header-cell *matHeaderCellDef class="dosator"></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="invisible9">
      <mat-header-cell *matHeaderCellDef class="table-header__products">
        {{ 'scheme-table.feed_unit_' + (isWeanedPigletsFeedadvice() ? 'gr' : 'kg') | translate }}
      </mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="invisible10">
      <mat-header-cell *matHeaderCellDef class="table-header__products">
        {{ 'scheme-table.feed_unit_kg' | translate }}
      </mat-header-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-header-row *matHeaderRowDef="displayedProductsColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
  </ng-container>
</mat-table>

<form *ngIf="isFattening()" [formGroup]="finalBodyWeightFormGroup">
  <div class="flex--row flex--nowrap spacing--margin-left spacing--margin-top">
    <div class="flex--column spacing--padding-right">
      <span class="text--small text--bold label">
        {{ 'scheme-table.final_weight' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--margin-left finalWeight">
      <span class="spacing--margin-top" *ngIf="!isEditMode">{{
        finalWeight | agrNumber: '1.1-1'
      }}</span>
      <ng-container *ngIf="isEditMode">
        <mat-form-field floatLabel="auto" subscriptSizing="dynamic" class="cell--input-field">
          <input
            matInput
            agrNumber
            [min]="0"
            [step]="0.1"
            data-test="scheme-table__final_weight_value"
            formControlName="finalWeight"
          />
        </mat-form-field>
      </ng-container>
    </div>
  </div>
</form>

<div class="mat-button-row spacing--margin-top" *ngIf="isEditMode">
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-add-bottom"
    (click)="changeNumberOfLines('add-bottom')"
  >
    <mat-icon>add</mat-icon>
    <ng-container *ngIf="isWeanedPiglets()">{{
      'scheme-table.buttons.add-day-bottom' | translate
    }}</ng-container>
    <ng-container *ngIf="!isWeanedPiglets()">{{
      'scheme-table.buttons.add-bottom' | translate
    }}</ng-container>
  </button>
  <button
    mat-stroked-button
    color="primary"
    style="font-size: 12px"
    data-test="scheme-table_button-remove-bottom"
    [disabled]="tableRows?.length <= 1"
    (click)="changeNumberOfLines('remove-bottom')"
  >
    <mat-icon>remove</mat-icon>
    <ng-container *ngIf="isWeanedPiglets()">{{
      'scheme-table.buttons.remove-day-bottom' | translate
    }}</ng-container>
    <ng-container *ngIf="!isWeanedPiglets()">{{
      'scheme-table.buttons.remove-bottom' | translate
    }}</ng-container>
  </button>

  <button
    mat-flat-button
    color="primary"
    style="float: right"
    data-test="feed-advice__calculate-columns"
    *ngIf="shouldCalculateDosatorColumns()"
    (click)="calculateDosatorColumns()"
  >
    <mat-icon>autorenew</mat-icon>{{ 'sows-feed-advice.buttons.calculate-columns' | translate }}
  </button>

  <mat-error
    style="float: right; margin-top: 10px"
    *ngIf="shouldCalculateDosatorColumns() && calculateColumnsValidationError !== undefined"
  >
    {{ calculateColumnsValidationError }}
  </mat-error>
</div>
